var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region-preview"},[_c('Subtitle',[_vm._v(_vm._s(_vm.region.name))]),_c('LabelLineValue',{attrs:{"label":"Device Count","value":_vm.region.deviceCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }